import {SetupWizardStep} from 'constants/SetupWizardEnum';
import {TrayType} from 'constants/dataEnum';
import {getSetupWizardCurrentStepData} from 'stores/business/setupWizardBusiness/commonSetupWizardBusiness';
import {setStepData} from 'stores/actions/wizardStateAction';
import GlobalReduxStore from 'stores/globalReduxStore';

import {isV2Instrument} from 'stores/business/instrumentStatusBusiness';

import {FirstPageSetupWizard, LastPageSetupWizard} from './FirstLastPageSetupWizard';
import StepFiveSetupWizard from './StepFiveSetupWizard';
import StepFourSetupWizard from './StepFourSetupWizard';
import StepOneSetupWizard from './StepOneSetupWizard';
import StepSevenSetupWizard from './StepSevenSetupWizard';
import StepSixSetupWizard from './StepSixSetupWizard';
import StepThreeSetupWizard from './StepThreeSetupWizard';
import StepTwoSetupWizard from './StepTwoSetupWizard';
import WrappedReportSetupWizard from './ReportSetupWizard';

export const FastV1SetupWizardStepsLists = [
  SetupWizardStep.AUTOMATED_ERROR_REPORT,
  SetupWizardStep.COLLISION_CALIBRATION,
  SetupWizardStep.TRAY_CALIBRATION,
  SetupWizardStep.A1_OFFSET_CALIBRATION,
  SetupWizardStep.VISION_CALIBRATION,
  SetupWizardStep.PLATE_DEFINITION,
  SetupWizardStep.PLATE_COPY_PROTOCOL,
];

export const FastV2SetupWizardStepsList = [
  SetupWizardStep.AUTOMATED_ERROR_REPORT,
  SetupWizardStep.TRAY_CALIBRATION,
  SetupWizardStep.TIPS_PICKUP_CALIBRATION,
  SetupWizardStep.VISION_CALIBRATION,
  SetupWizardStep.PLATE_DEFINITION,
  SetupWizardStep.PLATE_COPY_PROTOCOL,
];

export const SetupWizardComponent = {
  [SetupWizardStep.WELCOME_SCREEN]: FirstPageSetupWizard,
  [SetupWizardStep.AUTOMATED_ERROR_REPORT]: StepOneSetupWizard,
  [SetupWizardStep.COLLISION_CALIBRATION]: StepTwoSetupWizard,
  [SetupWizardStep.TRAY_CALIBRATION]: StepThreeSetupWizard,
  [SetupWizardStep.A1_OFFSET_CALIBRATION]: StepFourSetupWizard,
  [SetupWizardStep.TIPS_PICKUP_CALIBRATION]: StepFourSetupWizard,
  [SetupWizardStep.VISION_CALIBRATION]: StepFiveSetupWizard,
  [SetupWizardStep.PLATE_DEFINITION]: StepSixSetupWizard,
  [SetupWizardStep.PLATE_COPY_PROTOCOL]: StepSevenSetupWizard,
  [SetupWizardStep.REPORT]: WrappedReportSetupWizard,
  [SetupWizardStep.FINISH_SCREEN]: LastPageSetupWizard,
};

export const HighVolumeTrayStepExcludedList = [
  SetupWizardStep.A1_OFFSET_CALIBRATION,
  SetupWizardStep.TIPS_PICKUP_CALIBRATION,
];

export const getSetupWizardStepsList = () => {
  const {initialTrayType} = GlobalReduxStore.getState().wizardState;
  let stepList = isV2Instrument() ? FastV2SetupWizardStepsList : FastV1SetupWizardStepsLists;

  if (initialTrayType === TrayType.HIGH_VOLUME_CADDY) {
    stepList = stepList.filter((step) => !HighVolumeTrayStepExcludedList.includes(step));
  }

  return [SetupWizardStep.WELCOME_SCREEN, ...stepList, SetupWizardStep.REPORT, SetupWizardStep.FINISH_SCREEN];
};

export const getStepContent = (stepRef, intl, stepName) =>
  // eslint-disable-next-line func-names
  function (dispatch) {
    const stepData = dispatch(getSetupWizardCurrentStepData());
    const onSaveStepData = (param) => dispatch(setStepData(stepData.step, {...param}));

    const stepProps = {
      ref: stepRef,
      stepData,
      onSaveStepData,
      intl,
    };

    const Component = SetupWizardComponent[stepName];

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <Component {...stepProps} />;
  };
